import React, { useState } from 'react';
import { Filter, MapPin, MessageCircle, Calendar } from 'lucide-react';

const Discovery = ({ users, currentUser }) => {
  const [filter, setFilter] = useState('all');

  const filteredUsers = users.filter(user => {
    if (filter === 'online') return user.isOnline;
    if (filter === 'nearby') return parseFloat(user.distance) < 1;
    return true;
  });

  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Discover</h1>
        <p className="screen-subtitle">Find nomads and freelancers nearby</p>
      </div>

      {/* Filter Bar */}
      <div style={{ 
        padding: '0 20px 16px',
        display: 'flex',
        gap: '8px',
        overflowX: 'auto'
      }}>
        {['all', 'online', 'nearby'].map((filterType) => (
          <button
            key={filterType}
            onClick={() => setFilter(filterType)}
            style={{
              background: filter === filterType 
                ? 'linear-gradient(135deg, #667eea, #764ba2)' 
                : 'rgba(255, 255, 255, 0.8)',
              color: filter === filterType ? 'white' : '#666',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '20px',
              padding: '8px 16px',
              fontSize: '13px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(20px)',
              whiteSpace: 'nowrap'
            }}
          >
            {filterType.charAt(0).toUpperCase() + filterType.slice(1)}
          </button>
        ))}
      </div>

      {/* Users List */}
      <div style={{ paddingBottom: '20px' }}>
        {filteredUsers.map((user) => (
          <div key={user.id} className="user-card">
            <div className="user-header">
              <div style={{ position: 'relative' }}>
                <img src={user.avatar} alt={user.name} className="user-avatar" />
                {user.isOnline && <div className="online-indicator" />}
              </div>
              <div className="user-info">
                <div className="user-name">{user.name}</div>
                <div className="user-status">{user.status}</div>
              </div>
              <div className="user-distance">{user.distance}</div>
            </div>
            
            <div className="user-skills">
              {user.skills.map((skill, index) => (
                <span key={index} className="skill-tag">{skill}</span>
              ))}
            </div>

            <div style={{ 
              display: 'flex', 
              gap: '8px', 
              marginTop: '16px' 
            }}>
              <button style={{
                flex: 1,
                background: 'rgba(102, 126, 234, 0.1)',
                color: '#667eea',
                border: '1px solid rgba(102, 126, 234, 0.2)',
                borderRadius: '8px',
                padding: '10px',
                fontSize: '13px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px'
              }}>
                <MessageCircle size={14} />
                Message
              </button>
              <button style={{
                flex: 1,
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '10px',
                fontSize: '13px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px'
              }}>
                <Calendar size={14} />
                Invite
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Discovery;